<script setup lang="ts">
import type { Coin } from '@/lib/interfaces/calculator';
import { ListboxOption } from "@headlessui/vue";
import type { FuseResult } from "fuse.js";
import ContentItem from './ContentItem.vue';

interface Props {
  availableCoins: FuseResult<Coin>[];
}

defineProps<Props>();

const selectedCoins = defineModel<string[]>('selectedCoins', { required: true })

</script>

<template>
  <div class="space-y-2 h-full overflow-y-auto">
    <ListboxOption
      v-for="(coin, index) in (availableCoins as FuseResult<Coin>[]) /* TODO: useFuse has a typing issue, this is the best way to ensure type safety in the template. */"
      :key="index"
    >
      <ContentItem 
        :coin="coin"
        v-model:selectedCoins="selectedCoins"
      >
      </ContentItem>
    </ListboxOption>
  </div>
</template>
